import { AfterViewInit, Component, ElementRef, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { HString } from '@shared/src/public-api';
import { NgxScannerQrcodeComponent, ScannerQRCodeConfig, ScannerQRCodeDevice, ScannerQRCodeResult } from 'ngx-scanner-qrcode';

@Component({
  selector: 'shared-qrscanner',
  templateUrl: './shared.qrscanner.component.html',
  styleUrls: ['./shared.qrscanner.component.scss']
})
export class SharedQRScannerComponent implements AfterViewInit {
  constructor(private self: ElementRef) { }

  @ViewChild('scanner') scanner!: NgxScannerQrcodeComponent;
  @ViewChild('canvas') canvasElement!: ElementRef<HTMLCanvasElement>;

  @Input() showDeviceSelector: boolean = false;
  @Output() qrCodeScanned: EventEmitter<string> = new EventEmitter<string>();

  private _beepEnabled: boolean = true;
  @Input()
  set beepEnabled(value: boolean) {
    this._beepEnabled = value;
    this.config.isBeep = value;

    if (this.scanner)
      (this.scanner as any).isBeep = value;

  }

  public config: ScannerQRCodeConfig = {
    isBeep: true,
    constraints: {
      video: {
        facingMode: 'user',
        width: { ideal: 1024 },
        height: { ideal: 768 }
      }
    }
  }

  public devices: ScannerQRCodeDevice[] = [];
  public selectedDeviceId: string = '';

  public capturedImage: string | null = null; // Variable para almacenar la imagen capturada

  private isProcessing: boolean = false;
  public onEvent(e: ScannerQRCodeResult[], action?: any): void {
    if (this.isProcessing || e.length === 0) return;
    this.isProcessing = true;
    const qrValue = e[0].value;

    this.qrCodeScanned.emit(qrValue);

    // Cooldown de 3 segundos para que no lea todo el rato
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  ngAfterViewInit(): void {
    if (this.scanner) {
      setTimeout(() => {
        this.scanner.start().subscribe(() => {
          this.scanner.devices.subscribe((devices) => {
            this.devices = devices;
            if (devices.length > 0) {
              this.selectedDeviceId = devices[0].deviceId;
            }
          });
        });
      }, 500);
    }
  }

  onSelectDevice(deviceId: string): void {
    this.selectedDeviceId = deviceId;
    this.scanner.playDevice(deviceId);
  }

  startScanner(): void {
    if (this.scanner) {
      this.scanner?.start();
    }
  }

  stopScanner(): void {
    if (this.scanner) {
      this.scanner?.stop();
    }
  }

  // Al llamarla hace una foto, la devuelve y la almacena en una variable
  captureImage(): string {
    const canvas = this.canvasElement.nativeElement;
    const context = canvas.getContext('2d');
    const video = this.scanner.video?.nativeElement;

    if (video && context) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      this.capturedImage = canvas.toDataURL('image/jpg');
      return this.capturedImage
    }
  }

  // Descarga una imagen pasandole el string de la misma
  // Si no sele pasa descargará la última imagen hecha
  downloadImage(imageStr: string = ""): void {
    if (!HString.isNullOrNullString(imageStr)) {
      const link = document.createElement('a');
      link.href = imageStr;
      link.download = 'captured-image.jpg';
      link.click();

    } else if (this.capturedImage) {
      const link = document.createElement('a');
      link.href = this.capturedImage;
      link.download = 'captured-image.jpg';
      link.click();
    }
  }
}
